import React from "react";
import TopNav from "./components/top-nav";
import Navbar from "./components/Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Home";
// import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/outfit"; // Defaults to weight 400 (normal)
import "@fontsource/outfit/700.css"; // Bold (optional)

import Footer from "./components/Footer";
import About from "./About";
import Contact from "./Contact";
import BookAppointment from "./Book-appointment";
import Services from "./Services";
import Location from "./Location";
import Packages from "./Packages";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <TopNav />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/services" element={<Services />} />
          <Route path="/location" element={<Location />} />
          <Route path="/packages" element={<Packages />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
};

export default App;
